import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { GeneralComponent } from '../../General/g.component';
import { TopicService } from '../topic.service';
import { MessageService } from '../../shared/message.service';
import { BinarySearchComponent } from '../binary-search/binary-search.component';
import { TBinaryComponent } from '../t-binary/t-binary.component';
import { ActivatedRouteSnapshot } from '@angular/router';
import { NgForm } from '@angular/forms';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-playground',
  templateUrl: './playground.component.html',
  styleUrls: ['../binary/binary.component.css', '../hash/hash.component.css', './playground.component.css']
})
export class PlaygroundComponent extends GeneralComponent {

  exerciseType: string;
  elements: any[];
  elementType: string = "number";
  text: any;
  solved = false;

  //binary
  requestedElement: any;
  count: number;
  range: number[] = [0, 500];
  searchType: string = "binary";
  openCard: number = undefined;
  computeMiddle = false;
  limitRange = false;
  limitedRange = [];
  counter = 0;
  minCounterBinary: number;
  minCounterFibonacci: number;
  minCounterLinear: number = 0;
  middle: number;
  ficonaccis = [0, 1, 1, 2, 3, 5, 8, 13, 21, 34, 55, 89, 144, 233, 377, 610, 987, 1597];
  dropped: boolean = false;

  //hash
  selection: number[];
  typeFunction: string = "digits";
  scalar: number;
  divisor: number;
  compute: string[] = [];
  hashElements: boolean;
  linearProbing: boolean;

  precomputation: boolean = false;
  operation: boolean = false;
  scale: boolean = false;
  divide: boolean = false;

  length: number = 10;
  elementS: string = undefined;
  selectionS: string = undefined;

  caretPos: number = 0;

  hashed: any = [];
  selected: any = {};
  precomputationS: string;
  precomputationPosition: number;

  data: any[] = [];

  openElement: any = undefined;
  clicked = [];

  useAll: boolean = false;

  @ViewChild('definitionForm', {static:true}) public definitionForm: NgForm;

  constructor(protected topicService: TopicService, protected messageService: MessageService, protected http: HttpClient) {
    super(topicService);
    this.loadText();
  }

  /** loads the text to generate words from */
  loadText(): Promise<any> {
    let textFile = "./assets/text_" + this.topicService.getLanguage() + ".txt";
    let self = this;
    return new Promise((resolve, reject) => {
      this.http
        .get<string>(textFile)
        .subscribe(response => {
          self.text = response;
          resolve(true);
        })
    })
  }

  smallReset() {
    this.reset();
    this.generate();
  }

  reset() {
    this.counter = 0;
    this.solved = false;
    this.openCard = undefined;
    this.dropped = false;
    this.elements = [];
    this.count = undefined;
  }

  generateElements() {
    if (this.definitionForm.controls['elements'].valid && (this.exerciseType == 'hashElement' || this.definitionForm.controls["requestedElement"].valid) &&
      (this.elementType != "number" ||
        ((this.exerciseType == "hashElement" || this.exerciseType == 'findHash') && this.definitionForm.controls['length'].valid) ||
        ((this.exerciseType == "binarySearch" || this.exerciseType == "binaryInsert") && this.definitionForm.controls['rangeTo'].valid && this.definitionForm.controls['rangeFrom'].valid))) {
      this.elements = [];
      if (this.elementType == "number") {
        this.requestedElement = +this.requestedElement;
      }
      this.computeElements();

      if (this.exerciseType == "hashElement" || this.exerciseType == "findHash") {
        this.applyHashFunction(true);
      }
    }
  }

  applyHashFunction(direct: boolean = false) {
    if (this.typeFunction == 'digits') {
      this.computeBuckets();
    }
    if (this.typeFunction == 'checksum') {
      this.divisor = 10;
    }
    if(this.count > this.divisor && this.linearProbing){
      return;
    }
    if (direct ||
      (this.typeFunction == "digits" && this.definitionForm.controls["selectionS"].valid) || (this.typeFunction == 'checksum') ||
      (this.definitionForm.controls["scalar"].valid && this.definitionForm.controls["divisor"].valid && this.definitionForm.controls["selectionS"].valid)) {
      this.hashed = [];
      this.data = [];
      for (let i = 0; i < this.divisor; i++) {
        this.hashed.push([]);
        this.data.push({ name: i.toString(), value: 0 });
      }
      this.hashed.push([]);
      let last = this.hashed[this.hashed.length - 1]
      if (this.exerciseType == "findHash") {
        this.hashElements = true;
      }
      for (let element of this.elements) {
        let precomputed = undefined;
        let elem = {
          value: element,
          precomputed: precomputed,
          operation: undefined,
          scaled: undefined,
          hash: undefined
        };
        this.selected = elem;
        if (this.elementType == 'number') {
          this.precomputationS = element.toString().split("").join(",");
          this.changePrecomputation(this.exerciseType == 'findHash');
        } else {
          if (this.precomputation || this.exerciseType == "findHash") {
            this.precomputationS = element.toString().split("").map(v => v.toLowerCase().charCodeAt(0) - 6).join(",");
            this.changePrecomputation(this.exerciseType == 'findHash');
          }
        }
        if (this.exerciseType == "findHash") {
          this.hashElement(this.hashed.length - 1, false);
        }
        if (elem.hash == undefined || !this.hashElements) {
          last.push(elem)
        }
      }
      if (this.exerciseType == "findHash") {
        this.hashElements = false;
        this.selected = {
          value: this.requestedElement,
          precomputed: undefined,
          operation: undefined,
          scaled: undefined,
          hash: undefined,
          test: 1
        }
        if (this.elementType == 'number') {
          this.precomputationS = this.selected.value.toString().split("").join(",");
          this.changePrecomputation();
        } else {
          if (this.precomputation) {
            this.precomputationS = this.selected.value.toString().split("").map(v => v.toLowerCase().charCodeAt(0) - 96).join(",");
            this.changePrecomputation();
          }
        }
      }
    }
  }

  computeBuckets() {
    let maxHash = -1;
    for (let element of this.elements) {
      let precomputed = undefined;
      let elem = {
        value: element,
        precomputed: precomputed,
        operation: undefined,
        scaled: undefined,
        hash: undefined
      };
      this.selected = elem;
      if (this.elementType == 'number') {
        this.precomputationS = element.toString().split("").join(",");
        this.changePrecomputation(true);
      } else {
        if (this.compute.includes('precomputation')) {
          this.precomputationS = element.toString().split("").map(v => v.toLowerCase().charCodeAt(0) - 96).join(",");
          this.changePrecomputation(true);
        }
      }
      if (elem.hash > maxHash) {
        maxHash = elem.hash;
      }
    }
    this.divisor = maxHash + 1;
  }

  /** computes the elements, inserts the requested one and sorts them increasingly */
  computeElements() {
    if (this.exerciseType != "hashElement") {
      this.elements.push(this.requestedElement);
    }
    if (this.elementType == "number") {
      if (this.exerciseType == "binarySearch" || this.exerciseType == "binaryInsert") {
        let i = 0;
        while (i < this.count) {
          let elem = Math.floor(Math.random() * (this.range[1] - this.range[0]) + this.range[0]);
          while (this.elements.includes(elem)) {
            elem = Math.floor(Math.random() * (this.range[1] - this.range[0]) + this.range[0]);
          }
          this.elements.push(elem);
          i++;
        }

        this.elements = Array.from(new Set(this.elements));
        this.elements.sort();
        if (this.elementType == "number") {
          this.elements.sort((a, b) => (+a - +b));
        }
      } else {
        let i = 0;
        while (i < this.count) {
          let elem = "";
          for (var j = 0; j < this.length; j++) {
            elem = elem.concat(Math.floor(Math.random() * 10).toString());
          }
          while (this.elements.includes(elem)) {
            elem = "";
            for (var j = 0; j < length; j++) {
              elem = elem.concat(Math.floor(Math.random() * 10).toString());
            }
          }
          this.elements.push(elem);
          i++;
        }
      }
    } else { // elementType== 'string'
      this.computeElementsText(this.text.text);

    }


    if (this.exerciseType == "binaryInsert") {
      this.elements.splice(this.elements.indexOf(this.requestedElement), 1);
    }

    if (this.exerciseType == "findHash" && Math.random() > 0.75) {
      this.elements.splice(this.elements.indexOf(this.requestedElement), 1);
    }
    this.computeRange();

    this.computeTime();
    this.computeMiddleElement();
  }


  /** get random elements based on text */
  computeElementsText(text: string) {
    let words = text.replace(/[.,!:*+?^${}()|[\]\\]/g, "").split(" ").filter(v => v.length > 2).filter(v => v.length < 7);
    words = Array.from(new Set(words));
    while (this.elements.length <= this.count && words.length > 0) {
      let index = Math.ceil(Math.random() * words.length - 1);
      this.elements.push(words[index]);
      words.splice(index, 1);

    }
    this.elements = Array.from(new Set(this.elements.map(v => v.toUpperCase())));
    if (this.exerciseType != "hashElement") {
      this.requestedElement = this.requestedElement.toUpperCase();
    }
    this.elements.sort();
  }

  generate() {
    this.reset();
    switch (this.exerciseType) {
      case "binaryInsert":
      case "binarySearch": this.generateBinarySearch(); break;
      case "findHash": this.generateFindHash(); break;
      case "hashElement": this.generateHashElement(); break;
    }
  }

  generateBinarySearch() {
    this.elementType = Math.random() > 0.5 ? "number" : "string";

    this.count = Math.floor((Math.random() * 30) + 20);
    this.range[0] = Math.floor(Math.random() * 100);
    this.range[1] = Math.floor((Math.random() * 200) + (2 * this.count) + this.range[0]);
    if (this.elementType == "number") {
      this.requestedElement = Math.ceil(Math.random() * (this.range[1] - this.range[0])) + this.range[0];
    } else {
      let words = this.text.text.replace(/[.,!:*+?^${}()|[\]\\]/g, "").split(" ").filter(v => v.length > 2).filter(v => v.length < 7);
      words = Array.from(new Set(words));
      this.requestedElement = words[Math.floor(Math.random() * words.length)];
    }
    this.elements = [];
    this.computeElements();

    this.limitedRange = [];
    this.computeRange();
    this.computeMiddleElement();

    this.limitRange = Math.random() > 0.5;
    this.computeMiddle = Math.random() > 0.5;
  }

  generateHashElement() {
    this.elementType = "number";//Math.random() > 0.5 ? 'number' : "string";
    this.count = Math.floor(Math.random() * 20 + 10);
    this.length = this.elementType == 'number' ? Math.floor(Math.random() * 5 + 5) : 10;
    this.elements = [];
    this.computeElements();

    this.typeFunction = Math.random() > 0.33 ? "digits" : (Math.random() > 0.5 ? "checksum" : (Math.random() > 0.5 ? "multiplication" : "addition"));
    if (this.elementType == "string") {
      this.typeFunction = Math.random() > 0.5 ? "addition" : "multiplication";
    }

    let countSelection = this.typeFunction == 'digits' ? 2 : this.elementType == 'number' ? Math.floor(Math.random() * this.length / 2 + 1) : 3;
    let length = this.elementType == 'number' ? this.length : 5;
    this.selection = [];
    while (this.selection.length < countSelection) {
      let sel = Math.floor(Math.random() * length);
      if (!this.selection.includes(sel)) {
        this.selection.push(sel);
      }
    }
    this.scalar = Math.floor(Math.random() * 30) + 2;
    this.divisor = Math.floor(Math.random() * 20) + this.count;
    this.hashElements = Math.random() > 0.5;
    this.linearProbing = false;

    this.precomputation = Math.random() > 0.5;
    this.operation = Math.random() > 0.8;
    this.scale = Math.random() > 0.2;
    this.divide = Math.random() > 0.2;

    this.selectionS = this.selection.toString();
    this.applyHashFunction(true);
  }

  generateFindHash() {
    let words = this.text.text.replace(/[.,!:*+?^${}()|[\]\\]/g, "").split(" ").filter(v => v.length > 2).filter(v => v.length < 7);
    words = Array.from(new Set(words));
    if (this.elementType == "number") {
      this.requestedElement = "";
      for (var j = 0; j < this.length; j++) {
        this.requestedElement = this.requestedElement.concat(Math.floor(Math.random() * 10).toString());
      }
    } else {
      this.requestedElement = words[Math.floor(Math.random() * words.length)];
    }

    this.count = Math.floor(Math.random() * 20 + 10);
    this.length = this.elementType == 'number' ? Math.floor(Math.random() * 5 + 5) : 10;
    this.elements = [];
    this.computeElements();
    this.typeFunction = Math.random() > 0.33 ? "digits" : (Math.random() > 0.5 ? "checksum" : (Math.random() > 0.5 ? "multiplication" : "addition"));
    if (this.elementType == "string") {
      this.typeFunction = Math.random() > 0.5 ? "addition" : "multiplication";
    }

    let countSelection = this.typeFunction == 'digits' ? 2 : this.elementType == 'number' ? Math.floor(Math.random() * this.length / 2 + 1) : 3;
    let length = this.elementType == 'number' ? this.length : 5;
    this.selection = [];
    while (this.selection.length < countSelection) {
      let sel = Math.floor(Math.random() * length);
      if (!this.selection.includes(sel)) {
        this.selection.push(sel);
      }
    }
    this.scalar = Math.floor(Math.random() * 30) + 2;
    this.divisor = Math.floor(Math.random() * 20) + this.count;
    this.hashElements = false;
    this.linearProbing = false;

    this.precomputation = Math.random() > 0.5;
    this.operation = Math.random() > 0.8;
    this.scale = Math.random() > 0.2;
    this.divide = Math.random() > 0.2;

    this.selectionS = this.selection.toString();
    this.applyHashFunction(true);
  }

  /** opens card i */
  open(i: any) {
    if (this.solved) {
      return;
    }
    if (this.exerciseType != "findHash") {
      this.openCard = i;
      this.counter++;
      this.limitedRange = this.limitedRange.filter((v) => ((this.elements[i] >= this.requestedElement) == (i >= v)));
      if (this.elements[i] == this.requestedElement) {
        this.messageService.addAlertWithTimeout(this.get("elementFound"), "success", 5000);
        if (this.counter <= this.minCounterBinary && this.searchType == "binary") {
          this.messageService.addAlertWithTimeout(this.get("fasterOrEquallyFast"), "success", 5000);
        }
        else if (this.counter <= this.minCounterFibonacci && this.searchType == "fibonacci") {
          this.messageService.addAlertWithTimeout(this.get("fasterOrEquallyFast"), "success", 5000);
        }
        else if (this.counter <= this.minCounterLinear && this.searchType == "linear") {
          this.messageService.addAlertWithTimeout(this.get("fasterOrEquallyFast"), "success", 5000);
        } else {
          this.messageService.addAlertWithTimeout(this.get("slower"), "danger", 5000);
        }
        this.solved = true;
      } else {
        if (this.limitedRange.includes(i)) {
          this.limitedRange.splice(this.limitedRange.indexOf(i), 1);
        }
      }
      this.computeMiddleElement();
    } else {
      this.openElement = i;
      this.clicked.push(i.value);
      if (i.value == this.selected.value) {
        this.messageService.addAlertWithTimeout(this.get("foundElement"), "success", 10000);
        this.solved = true;
        this.checkFind();
      }
    }
  }

  /** computes the next card to open, based on the searchType */
  computeMiddleElement() {
    if (this.searchType == "binary") {
      this.middle = Math.ceil((this.limitedRange[0] + this.limitedRange[this.limitedRange.length - 1]) / 2 + 1);
    }
    else if (this.searchType == "fibonacci") {
      let smallestFibonacci = this.getFibonacciSplit(this.limitedRange.filter(v => Math.floor(v) == v).length);
      this.middle = this.limitedRange.filter(v => Math.floor(v) == v)[0] + smallestFibonacci;
    } else {
      if (this.counter == 0) {
        this.middle = 1;
      } else if (this.counter == 1) {
        this.middle = this.elements.length;
      } else {
        let myLimitedRange = this.limitedRange.filter(v => Math.floor(v) == v);
        let min = Math.max(myLimitedRange[0] - 1, 0);
        let max = Math.min(myLimitedRange[myLimitedRange.length - 1] + 1, this.elements.length - 1);
        this.middle = myLimitedRange[0] + Math.ceil(((this.requestedElement - this.elements[min]) /
          (this.elements[max] - this.elements[min])) * (myLimitedRange.length));
      }
    }

    if (Number.isNaN(this.middle)) {
      this.middle = -1;
    }
  }

  /**computes the time, the copmuter needs to find the card */
  computeTime() {
    let a = 0;
    let b = this.elements.length;
    let c = Math.ceil((a + b) / 2);
    this.minCounterBinary = 1;
    let i = 0;
    while (this.elements[c] != this.requestedElement && a < b) {
      this.minCounterBinary++;
      if (this.elements[c] > this.requestedElement) {
        b = c - 1;
      } else {
        a = c + 1;
      }
      c = Math.ceil((a + b) / 2);
      i++;
    }
    i = 0;
    a = 0;
    b = this.elements.length;
    c = this.getFibonacciSplit(b - a) - 1;
    this.minCounterFibonacci = 1;
    while (this.elements[c] != this.requestedElement && i < 20 && a < b) {
      this.minCounterFibonacci++;
      if (this.elements[c] > this.requestedElement) {
        b = c - 1;
      } else {
        a = c + 1;
      }
      c = a + this.getFibonacciSplit(b - a + 1) - 1;
      i++;

    }
    if (this.elementType == 'number') {
      a = 0;
      b = this.elements.length;
      let myLimitedRange = this.limitedRange.filter(v => Math.floor(v) == v);
      let min = Math.max(myLimitedRange[0] - 1, 0);
      let max = Math.min(myLimitedRange[myLimitedRange.length - 1] + 1, this.elements.length - 1);
      c = a + Math.ceil(((this.requestedElement - this.elements[min]) / (this.elements[max] - this.elements[min])) * (myLimitedRange.length)) - 1;
      this.minCounterLinear = 3;

      i = 0;
      while (this.elements[c] != this.requestedElement && i < 30 && this.elements[min] < this.requestedElement) {

        myLimitedRange = myLimitedRange.filter((v) => ((this.elements[c] >= this.requestedElement) == (c >= v))).filter((v, i) => i < b).filter((v, i) => (i >= a));

        this.minCounterLinear++;
        let min = Math.max(myLimitedRange[0] - 1, 0);
        let max = Math.min(myLimitedRange[myLimitedRange.length - 1] + 1, this.elements.length - 1);
        if (this.elements[c] > this.requestedElement) {
          b = c - 1;
        } else {
          a = c + 1;
        }
        //let min = Math.max(a - 1, 0);
        //let max = Math.min(b + 1, this.elements.length - 1);
        c = myLimitedRange[0] + Math.ceil(((this.requestedElement - this.elements[min]) /
          (this.elements[max] - this.elements[min])) * (myLimitedRange.length - 1));
        i++;
      }
    }
  }

  /** returns the fibonacci split */
  getFibonacciSplit(length: number): number {
    let smallestFibonacci = this.ficonaccis.map((v, i) => [v, i]).filter((v) => v[0] >= length)[0];
    if (smallestFibonacci[1] > 2) {
      return this.ficonaccis[smallestFibonacci[1] - 2];
    } else {
      return 1;
    }
  }

  computeRange() {
    if (this.limitedRange.length == 0) {
      this.limitedRange = this.createArray(this.elements.length);
      this.limitedRange = this.limitedRange.concat(this.limitedRange.map(v => v + 0.5));
      this.limitedRange.push(-0.5);
      this.limitedRange.sort((a, b) => (+a - +b));
    }
  }

  drop(index: number) {
    let correct = true;
    if (index >= 0 && this.elements[index] > this.requestedElement) {
      correct = false;
    }
    else if (index < this.elements.length - 1 && this.elements[index + 1] < this.requestedElement) {
      correct = false;
    }
    if (correct) {
      this.limitedRange = this.limitedRange.filter(v => v < index).concat(this.limitedRange.filter((v) => v > index).map(v => v + 1));
      if (this.limitedRange.length > 1) {
        this.limitedRange.push(index, index + 1);
      }
      this.openCard = -1;
      this.dropped = true;
      this.elements.splice(index + 1, 0, this.requestedElement);
      this.messageService.addAlertWithTimeout(this.get("correctPosition"), "success", 10000);
      if (index <= this.openCard) {
        this.openCard++;
      }
      this.solved = true;
    } else {
      this.messageService.addAlertWithTimeout(this.get("wrongPosition"), "danger", 10000);
    }
  }

  /** returns the maximal selected position */
  maxPosition(): number {
    if (this.elementType == "string") {
      return 10;
    }
    if (this.selection == undefined || this.selection == []) {
      return 1;
    } else {
      return Math.max(...this.selection) + 1;
    }
  }

  getHashFunction(): string {
    let separator = "";
    let result = "";
    if (this.typeFunction == 'digits') {
      if (this.selection) {
        for (let i of this.selection) {
          result = result.concat("a", i.toString());
        }
      }
      return result;
    }
    if (this.typeFunction == "checksum") {
      return this.get("checksum");
    }
    if (this.selection) {
      for (let i of this.selection) {
        result = result.concat(separator, "a".concat(i.toString()));
        separator = " * ";
        if (this.typeFunction == "addition") {
          separator = " + ";
        }
      }
      if (this.selection.length == 0) {
        if (this.typeFunction == "addition") {
          result = "a0 + a1 + ...";
        } else {
          result = "a0 * a1 * ...";
        }
      }
    } else {
    }
    result = "Rest von ((".concat(result, ")", " * ", this.scalar ? this.scalar.toString() : "???", ")", " / ", this.divisor ? this.divisor.toString() : "???")
    return result;
  }

  /** called when the fixed elements change */
  changeElements() {
    this.elements = this.elementS.split(",");
    if (this.elementType == "number") {
      this.elements = this.elements.map((v) => +v);
    }
    this.elements = Array.from(new Set(this.elements));
    this.elementS = this.elements.toString();
  }

  /** called when the fixed elements change */
  changeSelectionS() {
    this.selection = this.selectionS.split(",").map(v => +v);
    this.selection = Array.from(new Set(this.selection));
    this.selectionS = this.selection.toString();
    this.applyHashFunction();
  }
  getOperationString(): string {
    let result = "";
    if (this.selected.precomputed != undefined) {
      let separator = "";
      if (this.selection.length > 0) {
        for (let i of this.selection) {
          if (this.selected.precomputed[i] == undefined) {
            if (this.typeFunction == "addition") {
              result = result.concat(separator, "0");
            } else {

              result = result.concat(separator, "1");
            }

          } else {
            result = result.concat(separator, this.selected.precomputed[i]);
          }
          separator = " * ";
          if (this.typeFunction == "addition") {
            separator = " + ";
          }
        }
      } else {
        for (let i of this.selected.precomputed) {
          result = result.concat(separator, i);
          separator = " * ";
          if (this.typeFunction == "addition") {
            separator = " + ";
          }
        }

      }
    }
    return result;
  }

  onKeyUp(oField) {
    if (oField.selectionStart || oField.selectionStart == '0') {
      this.caretPos = oField.selectionStart;
    }
    if (this.precomputationS == undefined || this.precomputationS == "") {
      this.precomputationPosition = this.selected.value.toLowerCase().charCodeAt(0) - 96;
      return;
    }
    let myPart = this.precomputationS.substring(0, this.caretPos);
    let myNumbers = myPart.split(",");
    this.precomputationPosition = this.selected.value.toLowerCase().charCodeAt(myNumbers.length - 1) - 96;
  }

  changePrecomputation(test = false) {
    this.selected.precomputed = this.precomputationS.split(",").map(v => +v);
    this.computeOperation(test);
  }

  computeOperation(test = false) {
    if (!this.operation && !test) {
      return;
    }

    if (this.typeFunction == 'digits') {
      let result: any = "";
      for (let i of this.selection) {
        result = result.concat(this.selected.precomputed[i].toString());
      }

      result = +result;
      this.selected.hash = result;
      this.hashElement(this.hashed.length - 1, test);
      return;
    }
    if (this.typeFunction == "checksum") {
      let result: any = this.selected.value.toString();
      while (result.length > 1) {
        let temp = 0;
        for (let digit of result) {
          temp = temp + +digit;
        }
        result = temp.toString();
      }
      result = +result;
      this.selected.hash = result;
      this.hashElement(this.hashed.length - 1, test);
      return;
    }
    let result = 0;
    if (this.typeFunction == 'addition') {
      result = 0;
      if (this.selection.length > 0) {
        for (let i of this.selection) {
          if (this.selected.precomputed[i] != undefined) {
            result = result + this.selected.precomputed[i];
          }
        }
      } else {
        for (let i of this.selected.precomputed) {
          result = result + i;
        }
      }
    }
    else {
      result = 1;
      if (this.selection.length > 0) {
        for (let i of this.selection) {
          if (this.selected.precomputed[i] != undefined) {
            result = result * this.selected.precomputed[i];
          }
        }
      } else {
        for (let i of this.selected.precomputed) {
          result = result * i;
        }
      }
    }
    this.selected.operation = result;
    this.computeScale(test);
  }

  computeScale(test = false) {
    if (!this.scale && !test) {
      return;
    }
    this.selected.scaled = this.selected.operation * this.scalar;
    this.computeDivision(test);
  }

  computeDivision(test = false) {
    if (!this.divide && !test) {
      return;
    }
    let oldHash = this.selected.hash;
    this.selected.hash = this.selected.scaled % this.divisor;
    this.hashElement(oldHash, test);
  }

  hashElement(oldHash = this.hashed.length - 1, test = false) {
    if (this.selected.hash > this.hashed.length - 2) {
      return;
    }
    oldHash = this.hashed.length - 1;
    let i = 0;
    for (let bucket of this.hashed) {
      for (let elem of bucket) {
        if (elem.value == this.selected.value) {
          oldHash = i;
        }
      }
      i++;
    }
    if (this.hashElements && !test) {
      if (!this.linearProbing) {
        this.hashed[oldHash].splice(this.hashed[oldHash].indexOf(this.selected), 1);
        this.hashed[this.selected.hash].push(this.selected);
        this.data[this.selected.hash].value++;
        if (oldHash < this.hashed.length - 1) {
          this.data[oldHash].value--;
        }
        this.data = [...this.data];
      } else if (oldHash == this.hashed.length - 1) {
        this.hashed[oldHash].splice(this.hashed[oldHash].indexOf(this.selected), 1);
        let myBucketIndex: number = this.selected.hash;
        while (this.hashed[myBucketIndex % this.divisor].length > 0) {
          myBucketIndex++;
        }
        this.hashed[myBucketIndex % this.divisor].push(this.selected);
        this.data[myBucketIndex % this.divisor].value++;
      }
      else {
        let oldSelected = this.selected;
        let oldprecomputationS = this.precomputationS;
        let tempHashed = this.hashed;
        this.hashed = new Array();
        for (let i = 0; i < tempHashed.length; i++) {
          this.hashed.push([]);
        }

        for (let pair of this.data) {
          pair.value = 0;
        }
        for (let bucket of tempHashed.slice(0, tempHashed.length - 1)) {
          if (bucket.length > 0) {
            this.selected = bucket[0];
            this.hashElement(this.hashed.length - 1);
          }

        }

        this.hashed[tempHashed.length - 1] = tempHashed[tempHashed.length - 1];

        this.data = [...this.data];
        this.selected = oldSelected;
        this.precomputationS = oldprecomputationS;
      }
    }
  }

  fromCharCode(i: number): string {
    return String.fromCharCode(i);
  }

  hash(index: number, element: any) {
    if (this.linearProbing && this.hashed[index].length > 0) {
      this.messageService.addAlertWithTimeout(this.get("onlyOneCard"), "danger", 10000);
      return;
    }
    if (!this.linearProbing && index != element.dragData.element.hash) {
      this.messageService.addAlertWithTimeout(this.get("wrongBucket"), "danger", 10000);
      return;
    }
    this.hashed[index].push(element.dragData.element);
    this.hashed[element.dragData.start].splice(this.hashed[element.dragData.start].indexOf(element.dragData.element), 1);
    if (element.dragData.start < this.hashed - length - 1) {
      this.data[element.dragData.start].value--;
    }
    this.data[index].value++;
    this.data = [...this.data];
  }

  clickValue(element) {
    this.selected = element;
    if (this.selected.precomputed) {
      this.precomputationS = this.selected.precomputed.toString();
    } else {
      this.precomputationS = "";
    }
  }



  checkFind() {
    let toClick = [];
    let elem = {
      value: this.selected.value,
      precomputed: undefined,
      operation: undefined,
      scaled: undefined,
      hash: undefined,
    }
    let oldSelected = this.selected;
    let oldPrecomputation = this.precomputationS;
    this.selected = elem;
    if (this.elementType == 'number') {
      this.precomputationS = this.selected.value.toString().split("").join(",");
      this.changePrecomputation(true);
    } else {
      this.precomputationS = this.selected.value.toString().split("").map(v => v.toLowerCase().charCodeAt(0) - 96).join(",");
      this.changePrecomputation(true);
    }
    if (!this.linearProbing) {
      toClick = this.hashed[elem.hash].map(v => v.value);
    } else {
      let i = this.selected.hash;
      while (this.hashed[i % this.divisor].length > 0 && this.hashed[i % this.divisor][0].value != this.selected.value) {
        toClick.push(this.hashed[i % this.divisor][0].value);
        i++;
      }
      if (this.hashed[i % this.divisor].length > 0) {
        toClick.push(this.hashed[i % this.divisor][0].value);
      }
    }
    let error = false;
    for (let value of this.clicked) {
      if (!toClick.includes(value)) {
        error = true;
      }
    }

    if (error) {
      this.messageService.addAlertWithTimeout(this.get("TooManyCardsOpened"), "danger", 10000);
    } else {
      this.messageService.addAlertWithTimeout(this.get("correctNumberOfCards"), "success", 10000);
    }
    this.selected = oldSelected;
    this.precomputationS = oldPrecomputation;
  }

  notExisting() {
    if (this.elements.includes(this.selected.value)) {
      this.messageService.addAlertWithTimeout(this.get("YetExisting"), "danger", 10000);
      let elem = {
        value: this.selected.value,
        precomputed: undefined,
        operation: undefined,
        scaled: undefined,
        hash: undefined,
      }
      let oldSelected = this.selected;
      let oldPrecomputation = this.precomputationS;
      this.selected = elem;
      if (this.elementType == 'number') {
        this.precomputationS = this.selected.value.toString().split("").join(",");
        this.changePrecomputation(true);
      } else {
        this.precomputationS = this.selected.value.toString().split("").map(v => v.toLowerCase().charCodeAt(0) - 96).join(",");
        this.changePrecomputation(true);
      }
      this.selected = oldSelected;
      this.precomputationS = oldPrecomputation;
      if (elem.hash != this.selected.hash) {
        this.messageService.addAlertWithTimeout(this.get("CheckHashValue"), "danger", 10000);
      }
      return;
    }

    this.messageService.addAlertWithTimeout(this.get("CorrectlyNotFound"), "success", 10000);
    this.checkFind();
    this.solved = true;
  }


  checkSolution() {
    if (this.exerciseType != "hashElement") {
      this.messageService.addAlertWithTimeout(this.get("notFoundYet"), "danger", 10000);
    } else {
      if (this.hashed[this.hashed.length - 1].length > 0) {
        this.messageService.addAlertWithTimeout(this.get("notAllHashed"), "danger", 10000);
        return;
      }
      let error = false;
      let oldSelected = this.selected;
      let oldprecomputation = this.precomputationS;
      let temp = {};
      let index = 0;
      for (let bucket of this.hashed) {
        for (let elem of bucket) {
          temp = {
            value: elem.value,
            precomputed: undefined,
            operation: undefined,
            scaled: undefined,
            hash: undefined
          };
          this.selected = temp;
          if (this.elementType == 'number') {
            this.precomputationS = this.selected.value.toString().split("").join(",");
          } else {
            this.precomputationS = this.selected.value.toString().split("").map(v => v.toLowerCase().charCodeAt(0) - 96).join(",");
          }
          this.changePrecomputation(true);
          if (this.selected.hash != elem.hash) {
            this.messageService.addAlertWithTimeout(this.selected.value.toString().concat(": ", this.get("WrongHashValue")), "danger", 10000);
            error = true;
          }
          if (this.linearProbing) {
            let i = this.selected.hash;
            let myIndex = index;
            if (i > index) {
              myIndex += this.hashed.length;
            }
            while (i < myIndex) {
              if (this.hashed[i % this.divisor].length == 0) {
                this.messageService.addAlertWithTimeout(this.selected.value.toString().concat(": ", this.get("WrongBucket")), "danger", 10000);
                error = true;
                break;
              }
              i++;
            }
          }
        }
        index++;
      }
      if (!error) {
        this.messageService.addAlertWithTimeout(this.get("correct"), "success", 10000);
        this.solved = true;
      }
      this.selected = oldSelected;
      this.precomputationS = oldprecomputation;
    }
  }



}
